import { OfferAndPoolingAreaId } from './OfferAndPoolingAreaId'

const baseRoute = '/offer-and-pooling'
const createRoute = (subRoute: string) => ({
  route: `${baseRoute}/:serviceAreaId${subRoute}`,
  path: `/:serviceAreaId${subRoute}`,
})

export const OfferAndPoolingAreaRoutes = {
  route: baseRoute,
  title: `${OfferAndPoolingAreaId}:title`,
  OfferAndPoolingArea: createRoute('/'),
}
